import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import './index.scss'
const useStyles = makeStyles((theme) => ({
    typography: {
        padding: theme.spacing(2),
    },
}));

export default function SimplePopover({dateToday,turnover}) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [isShow,setIsShow] = React.useState('none');
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        let dom = document.querySelectorAll('.week-txt-triangle')
        for(let i = 0 , k = dom.length ; i < k ; i++ ){
            dom[i].style.display = 'none'
        }
        setIsShow('block');

    };

    const handleClose = () => {
        setAnchorEl(null);
        setIsShow('none');
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <div className="week-date-popover">
            <Button aria-describedby={id} variant="contained" color="primary" onClick={handleClick}>
                {dateToday}
                <em className="week-txt-triangle" style={{display:isShow}}></em>
            </Button>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
                  transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                  }}
            >
                <Typography className={classes.typography}>{turnover}</Typography>
            </Popover>
        </div>
    );
}
